var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgColorsIconGray(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7128_32635)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 12.7951C8.16344 13.3889 9.03955 13.75 10 13.75C12.0711 13.75 13.75 12.0711 13.75 10C13.75 8.27067 12.5794 6.81474 10.9874 6.38136M4.01261 6.38135C2.42058 6.81473 1.25 8.27066 1.25 10C1.25 12.0711 2.92893 13.75 5 13.75C7.07107 13.75 8.75 12.0711 8.75 10C8.75 9.51219 8.65686 9.04614 8.48739 8.61865M11.25 5C11.25 7.07107 9.57107 8.75 7.5 8.75C5.42893 8.75 3.75 7.07107 3.75 5C3.75 2.92893 5.42893 1.25 7.5 1.25C9.57107 1.25 11.25 2.92893 11.25 5Z",
    stroke: "#808795",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7128_32635"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorsIconGray);
export default __webpack_public_path__ + "static/media/colors-icon-gray.2bae93017083db9f4401b86129701c55.svg";
export { ForwardRef as ReactComponent };